export const GET_GRUPPI_DATA_AND_LOADING = "GET_GRUPPI_DATA_AND_LOADING";
export const CANCELA_GRUPPO_AND_LOADING = "CANCELA_GRUPPO_AND_LOADING";
export const GET_NUMBERS_FOR_GROUP = "GET_NUMBERS_FOR_GROUP";
export const MODIFY_GROUP = "MODIFY_GROUP";
